import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ReactiveFormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { IrisFormFieldModule } from '@sondermind/iris/form-field';
import { IrisTextInputModule } from '@sondermind/iris/text-input';
import { IrisDropdownModule } from '@sondermind/iris/dropdown';
import { IrisRadioGroupModule } from '@sondermind/iris/radio-group';
import { DirectiveModule } from '@sondermind/utilities/directives';
import { IrisCardModule } from '@sondermind/iris/card';
import { IrisTextAreaModule } from '@sondermind/iris/text-area';
import { IrisCheckboxModule } from '@sondermind/iris/checkbox';
import { IrisButtonModule } from '@sondermind/iris/button';
import { MatchingUtilitiesModule } from '@sondermind/features/matching-utilities';
import { IrisEmptyStateModule } from '@sondermind/iris/empty-state';
import { GoogleMapsAutoCompleteDirective } from '@sondermind/google-maps';
import { QuickIntakeHostComponent } from './components/quick-intake-host/quick-intake-host.component';
import { QuickIntakeFormComponent } from './components/quick-intake-form/quick-intake-form.component';
import { QuickIntakeHeaderComponent } from './components/quick-intake-header/quick-intake-header.component';
import { QuickIntakeTextFooterComponent } from './components/quick-intake-text-footer/quick-intake-text-footer.component';
import { QuickIntakeAppDownloadFooterComponent } from './components/quick-intake-app-download-footer/quick-intake-app-download-footer.component';

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    IrisFormFieldModule,
    IrisTextInputModule,
    IrisDropdownModule,
    IrisRadioGroupModule,
    DirectiveModule,
    ReactiveFormsModule,
    IrisCardModule,
    IrisTextAreaModule,
    IrisCheckboxModule,
    IrisButtonModule,
    IrisRadioGroupModule,
    IrisEmptyStateModule,
    MatExpansionModule,
    MatchingUtilitiesModule,
    GoogleMapsAutoCompleteDirective
  ],
  declarations: [
    QuickIntakeHostComponent,
    QuickIntakeFormComponent,
    QuickIntakeHeaderComponent,
    QuickIntakeTextFooterComponent,
    QuickIntakeAppDownloadFooterComponent
  ],
  exports: [
    QuickIntakeHostComponent
  ]
})
export class QuickIntakeModule {}
